module.exports = require("babel-runtime/helpers/typeof");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/typeof"
// module id = 19
// module chunks = 0